/* ZINKE — Newsletter ohne Pop-up, 21.09.2026 (Theme 4.9)

   GEÄNDERT 22.09.2026 — Code kommt NUR NOCH PER MAIL
   - Der /discount/<code>-Aufruf ist entfernt: der Code landet nicht mehr von
     selbst im Warenkorb.
   - Der Kopierknopf entfällt, weil der Code im Dankschritt nicht mehr steht.
   - NEU: dieselbe Adressprüfung wie im Pop-up. Die feste Anmeldung hatte
     vorher gar keine — hier kam jede Fantasieadresse durch.

   Zwei Dinge, beide bewusst hier und nicht in assets/zinke-newsletter.js:
   die grosse Datei bleibt unangetastet.

   1. LEISTE SPAETER (Pascal, 21.09.: 25 statt 15 Sekunden)
      zinke-newsletter.js baut die schmale Leiste nach 15 sichtbaren Sekunden.
      Die Zahl steckt dort in einer Konstante. Statt die Datei umzuschreiben,
      haelt dieses Skript die Leiste per CSS zurueck, bis 25 sichtbare
      Sekunden voll sind.

      WICHTIG (beim Testen am 21.09. aufgefallen): zinke-newsletter.js stoppt
      seine Sekundenuhr in dem Moment, in dem es die Leiste baut. Der Zaehler
      zinkeNlSekunden bleibt danach auf 15 stehen und erreicht nie 25. Dieses
      Skript zaehlt deshalb selbst weiter, in einem eigenen Schluessel, und
      startet dabei vom hoeheren der beiden Werte — so laeuft die Zeit ueber
      Seitenwechsel hinweg richtig weiter.

   2. FESTE ANMELDUNG (Fussbereich und /pages/newsletter)
      Nach erfolgreicher Anmeldung legt Shopify den Kunden an und laedt die
      Seite mit customer_posted=true neu. Liquid zeigt dann den Dankschritt
      (snippets/zinke-nl-fest.liquid). Dieses Skript merkt sich die Anmeldung,
      damit Leiste und Pop-up danach Ruhe geben.

      Auf /pages/newsletter kann mehr als ein Block auf der Seite stehen,
      deshalb ueberall querySelectorAll.
*/
(function () {
  'use strict';

  var WARTE = 25;
  var K_FREMD = 'zinkeNlSekunden';
  var K_EIGEN = 'zinkeNl49Sekunden';
  var K_DABEI = 'zinkeNlAngemeldet';

  function lesen(s, k) { try { return window[s].getItem(k); } catch (e) { return null; } }
  function schreiben(s, k, v) { try { window[s].setItem(k, v); } catch (e) {} }
  function zahl(s, k) { return parseInt(lesen(s, k) || '0', 10) || 0; }

  /* ---------- 1. Leiste zurueckhalten ---------- */
  function leisteBremsen() {
    var gesammelt = Math.max(zahl('sessionStorage', K_FREMD), zahl('sessionStorage', K_EIGEN));
    if (gesammelt >= WARTE) return;

    var stil = document.createElement('style');
    stil.id = 'ZinkeNlBremse';
    stil.textContent = '.zinke-nl-leiste{display:none !important}';
    document.head.appendChild(stil);

    var uhr = setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      gesammelt = Math.max(gesammelt + 1, zahl('sessionStorage', K_FREMD));
      schreiben('sessionStorage', K_EIGEN, String(gesammelt));
      if (gesammelt < WARTE) return;
      clearInterval(uhr);
      var b = document.getElementById('ZinkeNlBremse');
      if (b) b.remove();
    }, 1000);
  }

  /* ---------- 2. Adresspruefung (22.09., gleiche Regeln wie im Pop-up) ---------- */
  var WEGWERF = ['mailinator.com','yopmail.com','yopmail.fr','trashmail.com','trashmail.de','10minutemail.com','10minutemail.de','guerrillamail.com','guerrillamail.de','sharklasers.com','temp-mail.org','tempmail.com','tempmailo.com','throwawaymail.com','getnada.com','dispostable.com','fakeinbox.com','maildrop.cc','mailnesia.com','spamgourmet.com','wegwerfemail.de','byom.de','muellmail.com','einrot.com','tempr.email','emailondeck.com','moakt.com','mohmal.com','luxusmail.org','inboxkitten.com','mail.tm','1secmail.com','minuteinbox.com','discard.email','tempmail.net','mailsac.com','trashmail.net','spam4.me'];
  var BEISPIEL = ['example.com','example.org','example.net','example.edu','example.de','beispiel.de','beispiel.com','test.de','test.com','testmail.de','muster.de','mustermann.de','musterfirma.de','domain.com','asdf.de','asdf.com','aaa.de','abc.de','xxx.de'];
  var BEISPIEL_TLD = ['test','invalid','local','localhost','example','internal','lan'];
  var FANTASIE = /^(max[._-]?mustermann|erika[._-]?mustermann|mustermann|maxmuster|john[._-]?doe|jane[._-]?doe|test\d*|testtest|test[._-]?mail|asdf+|qwert\w*|abcdef?|aaa+|xxx+|fake|dummy|kein[._-]?name|nobody|niemand)$/;

  function pruefen(wert, tFehler, tWegwerf) {
    var v = (wert || '').trim();
    if (v.length < 6 || v.length > 254) return tFehler;
    if (!/^[^\s@,;:<>()\[\]\\"]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v)) return tFehler;
    if (/\.\./.test(v)) return tFehler;
    var teile = v.toLowerCase().split('@');
    var lokal = teile[0], domain = teile[1];
    var tld = domain.split('.').pop();
    if (tld.length < 2 || /[^a-z]/.test(tld)) return tFehler;
    if (lokal.length < 2) return tFehler;
    if (BEISPIEL_TLD.indexOf(tld) > -1) return tWegwerf;
    if (BEISPIEL.indexOf(domain) > -1) return tWegwerf;
    if (/^example\./.test(domain)) return tWegwerf;
    if (WEGWERF.indexOf(domain) > -1) return tWegwerf;
    if (FANTASIE.test(lokal)) return tWegwerf;
    return '';
  }

  /* ---------- 3. Feste Anmeldung ---------- */
  function festeAnmeldung() {
    var bloecke = document.querySelectorAll('[data-zinke-nl-fest]');
    if (!bloecke.length) return;

    var erfolg = false;
    Array.prototype.forEach.call(bloecke, function (block) {
      if (block.querySelector('[data-zinke-nl-fest-erfolg]')) erfolg = true;

      var form = block.querySelector('form');
      var feld = block.querySelector('input[type="email"]');
      var fehler = block.querySelector('[data-zinke-nl-fest-fehler]');
      if (!form || !feld || !fehler) return;

      var tFehler = block.getAttribute('data-t-fehler') || '';
      var tWegwerf = block.getAttribute('data-t-wegwerf') || tFehler;

      form.addEventListener('submit', function (e) {
        fehler.hidden = true;
        var meldung = pruefen(feld.value, tFehler, tWegwerf);
        if (!meldung) return;
        e.preventDefault();
        fehler.textContent = meldung;
        fehler.hidden = false;
        feld.focus();
      });
      feld.addEventListener('input', function () { fehler.hidden = true; });
    });

    if (!erfolg) return;
    schreiben('localStorage', K_DABEI, '1');
    var leiste = document.querySelector('.zinke-nl-leiste');
    if (leiste) leiste.remove();
  }

  function start() {
    leisteBremsen();
    festeAnmeldung();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
